module.exports = __webpack_public_path__ + "static/media/fall.35edd6bf.jpg";